import MODULE_KEYWORDS from 'components/Modules/keywords';
import { PAYMENT_TABLE_CONTEXTS } from './paymentPaycutFields';

const ORDERS_CONTROL_KEY = MODULE_KEYWORDS.MODULES.ITEMS.KEYS.ORDERS.CONTROL;

export const isOrdersControlRootTable = (selectedSubModule, tableContext) =>
	selectedSubModule?.key === ORDERS_CONTROL_KEY &&
	tableContext === PAYMENT_TABLE_CONTEXTS.ROOT_STANDARD_TABLE;

export const prepareOrdersControlFields = (
	fields = [],
	selectedSubModule,
	tableContext,
	selectionEnabled = true,
) => {
	if (!isOrdersControlRootTable(selectedSubModule, tableContext)) return fields;

	const indexFields = fields.filter(field => field.id === 'index');
	const visibleFields = fields.filter(field => field.id !== 'index');
	const orderField = visibleFields.find(field => field.id === 'odtId');

	if (!orderField) return visibleFields;

	const reclaimedWidth = indexFields.reduce(
		(total, field) => total + (Number(field.width) || 0),
		0,
	);
	const orderWidth = Number(orderField.width) || 0;
	const preparedOrderField = {
		...orderField,
		name: 'Orden',
		ordersControlPrimaryField: true,
		ordersControlSelectionEnabled: selectionEnabled,
		width: orderWidth + reclaimedWidth,
	};

	return [
		preparedOrderField,
		...visibleFields.filter(field => field.id !== 'odtId'),
	];
};
